var map = {
	"./session-background": "./app/javascript/images/session-background.png",
	"./session-background-sp": "./app/javascript/images/session-background-sp.png",
	"./session-background-sp.png": "./app/javascript/images/session-background-sp.png",
	"./session-background.png": "./app/javascript/images/session-background.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";